module.exports = ":host .dropdown-btn {\n  background-color: #399cc7;\n  padding: 0;\n  width: 216px; }\n  :host .dropdown-btn img {\n    position: absolute;\n    left: 8px;\n    top: calc((38px - 28px) / 2); }\n  :host .dropdown-btn .dropdown-arrow {\n    position: absolute;\n    right: 0;\n    top: 0;\n    font-size: 36px;\n    border-top-right-radius: 2px;\n    border-bottom-right-radius: 2px;\n    margin-left: 8px;\n    background-color: #2392b4;\n    width: 38px;\n    height: 38px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/navbar/menu/menu.component.scss
// module id = ./src/app/shared/navbar/menu/menu.component.scss
// module chunks = main